import React, { useEffect } from 'react';
import { isBoolean } from 'lodash';

import beFeed from 'actions/activity/beFeed.action';
import { aTypeUpdateActivityFeed } from 'actions/shared.types';
import PUSHER from 'config/pusher.singleton';
import useTip from 'hooks/useTip.hook';
import { useDispatcher } from 'providers/Dispatcher.provider';
import { PUSHER_EVENT_BOOKING_TYPE, PUSHER_EVENT_CLIENT, PUSHER_EVENT_INFO, PUSHER_EVENT_MISSED_CALL, PUSHER_EVENT_SMS_THREAD } from 'providers/Pusher.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import logger from 'utils/logger.util';
import C from 'utils/values/constant.util';

import { CLIENT_PUSHER } from 'lib/constants/currentSalon';

const L = logger('ActivityWatcher');

const NOTIFICATION_GROUPS = C({
  activityFeedNotifications: {
    messageTypes: [PUSHER_EVENT_BOOKING_TYPE, PUSHER_EVENT_SMS_THREAD, PUSHER_EVENT_INFO, PUSHER_EVENT_MISSED_CALL],
    actionToFire: aTypeUpdateActivityFeed.name,
  },
  clientDataNotifications: {
    messageTypes: [PUSHER_EVENT_CLIENT],
    actionToFire: CLIENT_PUSHER,
  },
});

const subscribeGroups = ({ salonId, groups }) => {
  L.info('Subscribing...');

  const channelName = `${salonId}_channel`;

  for (const group of groups) {
    if (isBoolean(group)) continue;

    for (const type of group.messageTypes) {
      PUSHER.redux.subscribe({ channelName, eventName: type, actionType: group.actionToFire });
    } // for type
  } // for group

  // noinspection UnnecessaryLocalVariableJS
  const unsubscribeGroups = () => {
    L.info('Unsubscribing...');

    for (const group of groups) {
      if (isBoolean(group)) continue;

      const actionType = group.actionToFire;
      for (const eventName of group.messageTypes) {
        PUSHER.redux.unsubscribe({ channelName, eventName, actionType });
      } // for type
    } // for group
  };

  return unsubscribeGroups;
};

const ActivityWatcher = () => {
  const salonId = useCurrentSalonId();
  const dispatchBeFeed = useDispatcher(beFeed);
  const { val: isFeedFetched, inv: isFeedNotFetched, yay: markFetched } = useTip(false);

  useEffect(() => {
    if (salonId && isFeedNotFetched) {
      L.unignore('useEffect()', 'dispatchBeFeed:', dispatchBeFeed({ page: 1 }));
      markFetched();
    }

    return subscribeGroups({ salonId, groups: Object.values(NOTIFICATION_GROUPS) });
  }, [dispatchBeFeed, isFeedFetched, isFeedNotFetched, markFetched, salonId]);

  return <div data-bem="ActivityWatcher" id="activity-watcher" />;
};

export default ActivityWatcher;
